import { UserViewModelModule_ofDomain, UserViewModelModule_empty } from "../ThreeDocs.Models/View/UserViewModel.js";
import { DefaultActions_terminate, DefaultActions_Types_UpdateArgs$3, DefaultActions_runUpdate, DefaultActions_create, DefaultActions_Types_ChildModel$2, Child$1 } from "../Common/Terminate.js";
import { Msg, Model, childAbsentStrategy } from "./UserProfileTypes.js";
import { Cmd_map, Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.25.0/String.js";
import { some } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { ofArray, singleton } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Cmd_OfAsyncWith_attempt, Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { publicAuthApi, securedUserManagementApi } from "../Api.js";
import { success, error } from "../ThreeDocs.SharedUI/Toast.js";
import { Common_EmailAddress_create_Z721C83C5, Security_AuthErrorMessage_get_describe, Common_EmailAddress_value_Z39D6D3C1 } from "../fable_modules/Webbler.Models.1.3.1/Api.fs.js";
import { tryTerminate, update as update_1, init as init_1 } from "../EmailChange/EmailChangeState.js";
import { InitArgs } from "../EmailChange/EmailChangeTypes.js";

export function init() {
    return [new Model(UserViewModelModule_empty, new DefaultActions_Types_ChildModel$2(new Child$1(1, []), childAbsentStrategy, "Email Change"), false), Cmd_none()];
}

export function update(token, userInfo, msg, model) {
    let matchValue, emailChange, matchValue_1, matchValue_2;
    let matchResult, exn, maybeUserInfo, setter, e, user, e_1, msg_5, msg_6;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            break;
        }
        case 3: {
            if (msg.fields[0].tag === 1) {
                matchResult = 8;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 3;
                maybeUserInfo = msg.fields[0].fields[0];
            }
            break;
        }
        case 4: {
            matchResult = 4;
            setter = msg.fields[0];
            break;
        }
        case 5: {
            matchResult = 5;
            break;
        }
        case 6: {
            if (msg.fields[0].tag === 1) {
                matchResult = 8;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 7: {
            matchResult = 7;
            break;
        }
        case 8: {
            if (msg.fields[0].tag === 2) {
                matchResult = 9;
            }
            else {
                matchResult = 10;
            }
            break;
        }
        case 9: {
            matchResult = 11;
            user = msg.fields[0];
            break;
        }
        case 10: {
            matchResult = 12;
            break;
        }
        case 11: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                e_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 13;
            }
            break;
        }
        case 12: {
            if (msg.fields[0].chainedMsg.tag === 0) {
                matchResult = 16;
                msg_6 = msg.fields[0];
            }
            else {
                matchResult = 15;
                msg_5 = msg.fields[0].chainedMsg.fields[0];
            }
            break;
        }
        case 13: {
            matchResult = 17;
            break;
        }
        default: {
            matchResult = 0;
            exn = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0: {
            console.error(some(toText(printf("Error: %O"))(exn)));
            return [model, Cmd_none()];
        }
        case 1:
            return [model, singleton((dispatch) => {
                dispatch(new Msg(2, []));
            })];
        case 2:
            return [model, Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, securedUserManagementApi(token).getCurrentUserInfo, undefined, (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(0, [Item_1])))];
        case 3:
            if (maybeUserInfo == null) {
                return [model, error("Unable to find User Info")];
            }
            else {
                return [new Model(UserViewModelModule_ofDomain(maybeUserInfo), model.emailChange, false), Cmd_none()];
            }
        case 4:
            return [new Model(setter(model.userInfo), model.emailChange, true), Cmd_none()];
        case 5:
            return [model, Cmd_OfAsyncWith_either((x_1) => {
                AsyncHelpers_start(x_1);
            }, securedUserManagementApi(token).editUser, model.userInfo, (Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(0, [Item_3])))];
        case 6:
            return [model, Cmd_batch(ofArray([success("Successfully updated Profile Information"), singleton((dispatch_1) => {
                dispatch_1(new Msg(2, []));
            })]))];
        case 7:
            return [model, Cmd_batch(ofArray([Cmd_OfAsyncWith_attempt((x_2) => {
                AsyncHelpers_start(x_2);
            }, publicAuthApi.requestPasswordResetTokenEmail, Common_EmailAddress_value_Z39D6D3C1(userInfo.email), (Item_4) => (new Msg(0, [Item_4]))), success("An email has been sent to the specified address")]))];
        case 8:
            return [model, error(Security_AuthErrorMessage_get_describe()(e))];
        case 9:
            return [model, singleton((dispatch_2) => {
                dispatch_2(new Msg(2, []));
            })];
        case 10:
            return [model, Cmd_none()];
        case 11: {
            const createdEmailChange = init_1(new InitArgs(user));
            const patternInput = DefaultActions_create(createdEmailChange[0], createdEmailChange[1], model.emailChange);
            return [new Model(model.userInfo, patternInput[0], model.hasChanged), Cmd_map((Item_5) => (new Msg(12, [Item_5])), patternInput[1])];
        }
        case 12:
            return [model, (matchValue = model.emailChange.child, (matchValue.tag === 0) ? ((emailChange = matchValue.fields[0], (matchValue_1 = Common_EmailAddress_create_Z721C83C5(emailChange.currentEmail), (matchValue_2 = Common_EmailAddress_create_Z721C83C5(emailChange.newEmail), (matchValue_1.tag === 1) ? error("The users current email is invalid. Please try reloading the page") : ((matchValue_2.tag === 1) ? error("The new email is invalid. Please enter a valid email address.") : Cmd_OfAsyncWith_either((x_3) => {
                AsyncHelpers_start(x_3);
            }, publicAuthApi.requestEmailChangeTokenEmail, [emailChange.currentEmail, emailChange.newEmail], (Item_6) => (new Msg(11, [Item_6])), (Item_7) => (new Msg(0, [Item_7])))))))) : error("An email change component has not been created yet"))];
        case 13:
            return [model, Cmd_batch(ofArray([success("A confirmation email has been sent to the users current email address"), singleton((dispatch_3) => {
                dispatch_3(new Msg(13, []));
            })]))];
        case 14:
            return [model, error(Security_AuthErrorMessage_get_describe()(e_1))];
        case 15:
            return [model, Cmd_none()];
        case 16: {
            const patternInput_1 = DefaultActions_runUpdate(new DefaultActions_Types_UpdateArgs$3((msg_7, model_2) => {
                if (msg_7.tag === 1) {
                    return [model_2, Cmd_none()];
                }
                else {
                    return update_1(undefined, msg_7.fields[0], model_2);
                }
            }, model), model.emailChange, msg_6);
            return [new Model(model.userInfo, patternInput_1[0], model.hasChanged), Cmd_map((Item_8) => (new Msg(12, [Item_8])), patternInput_1[1])];
        }
        default: {
            const patternInput_2 = DefaultActions_terminate(tryTerminate, model.emailChange);
            return [new Model(model.userInfo, patternInput_2[0], model.hasChanged), Cmd_batch(ofArray([Cmd_map((Item_9) => (new Msg(12, [Item_9])), patternInput_2[1]), singleton((dispatch_4) => {
                dispatch_4(new Msg(2, []));
            })]))];
        }
    }
}

